<template>
  <button
    type="button"
    class="btn btn-danger small-button d-flex align-items-center justify-content-center fw-bold p-3"
  >
    -
  </button>
</template>

<script>
export default {
  name: 'RulePropertyRemove',
}
</script>

<style lang="scss" scoped>
.small-button {
  width: 1.75rem;
  height: 1.75rem;
}
</style>
